import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#approche", label: "Approche", anchor: true },
  { href: "#expertise", label: "Expertise", anchor: true },
  { href: "#services", label: "Accompagnements", anchor: true },
  { href: "/constellations-en-groupe", label: "Constellations", anchor: false },
  { href: "#faq", label: "FAQ", anchor: true },
];

export default function Navbar({ onBookingClick }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkHref = (link) => {
    if (!link.anchor) return link.href;
    return isHome ? link.href : `/${link.href}`;
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAF7F8]/85 border-b border-[#DDD7E2]/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-tight">
          <span className="font-serif-display text-2xl text-[#1E1E2A]">Francine Banzadio</span>
          <span className="text-[10px] tracking-[0.25em] uppercase text-[#5F6170] mt-0.5">
            Psychotraumas · Schémas émotionnels
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={linkHref(l)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-[#1E1E2A] hover:text-[#2847B8] transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={onBookingClick}
            data-testid="nav-booking-btn"
            className="bg-[#2847B8] text-white hover:bg-[#3A2E6E] transition-all duration-300 rounded-full px-6 py-2.5 text-sm font-medium"
          >
            Prendre rendez-vous
          </button>
        </nav>

        <button
          className="lg:hidden text-[#1E1E2A] p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FAF7F8] border-t border-[#DDD7E2]/60 px-6 py-6 space-y-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={linkHref(l)}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="block text-base text-[#1E1E2A] hover:text-[#2847B8]"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              onBookingClick();
            }}
            data-testid="nav-mobile-booking-btn"
            className="w-full bg-[#2847B8] text-white rounded-full px-6 py-3 text-sm font-medium"
          >
            Prendre rendez-vous
          </button>
        </div>
      )}
    </header>
  );
}
